import { useSelector } from "react-redux";
import {
  Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay,
  Center, Text, Image, Box, Button
} from "@chakra-ui/react";
import { BASE_API_URL } from "../../../../Api/constants";
import FileView from "../../../NewChat/UI/FileView/Public";

const FileViewer = ({ file, texts = {} }) => {
  const fileManagerTexts = texts?.fileManager || {};
  const { UserAccessToken } = useSelector((state) => state.Auth);
  const Token = localStorage.getItem("token") || "";

  if (!file?.FileId) return null;

  // Build direct URL with auth token — browser streams natively (no blob download)
  const buildUrl = (type) => {
    const url = new URL(`${BASE_API_URL}folder/file/${file.FileId}`);
    url.searchParams.set("Type", type);
    url.searchParams.set("X-T", Token);
    return url.toString();
  };

  if (file.FileType === "img") {
    return (
      <Image
        src={buildUrl("View")}
        alt={file.OriginalName}
        maxH="80vh"
        objectFit="contain"
      />
    );
  }

  if (file.FileType === "pdf") {
    return (
      <Box
        as="iframe"
        src={buildUrl("View")}
        width="100%"
        height="80vh"
        title={file.OriginalName}
      />
    );
  }

  return (
    <Center h="300px" flexDirection="column" gap={4}>
      <Text>
        {fileManagerTexts.previewNotAvailable ||
          "Preview is not available for this file type."}
      </Text>
      <Button
        as="a"
        href={buildUrl("Download")}
        download={file.OriginalName}
        sx={{
          bg: "var(--upload-submit-bg)",
          color: "var(--btn-special-text)",
          _hover: { bg: "var(--upload-submit-hover-bg)" },
        }}
      >
        {fileManagerTexts.downloadFile || "Download File"}
      </Button>
    </Center>
  );
};

export default function ViewFileModal({
  OnClose = () => {},
  IsOpen = false,
  Selected = null,
  texts = {},
}) {
  const fileManagerTexts = texts?.fileManager || {};

  return (
    <Modal isOpen={IsOpen} onClose={OnClose} isCentered size="4xl">
      <ModalOverlay />
      <ModalContent sx={{ bg: "var(--modal-bg)", color: "var(--modal-text)" }}>
        <ModalHeader
          my={0}
          py={2}
          borderBottomWidth="1px"
          sx={{ borderColor: "var(--modal-border-color)" }}
        >
          {Selected?.OriginalName || fileManagerTexts.viewFile || "View File"}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody p={2}>
          {/* {Selected ? <FileViewer file={Selected} texts={texts} /> : null} */}
          <FileView
            File={Selected}
            AllowDownload={true}
            FolderFile={true}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
